import { useEffect } from "react";
import { useAppDispatch } from "../../../../../../store/config";
import { resetWorkouts } from "../../../../../../store/features/workouts/workouts-slice";
import { WorkoutsLayout } from "./style";
import { Outlet } from "react-router-dom";

export const Workouts = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetWorkouts());
    };
  }, []);

  return (
    <WorkoutsLayout>
      <Outlet />
    </WorkoutsLayout>
  );
};
